import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FadeInSlider } from '../../components';

const Wrapper = styled.div`
  margin-top: 28px;

  @media (max-width: 1024px) {
    margin-top: 98px;
    margin-bottom: 90px;
  }
`;

const HeaderTitle = styled.div`
  position: relative;
  font-family: CeraStencil;
  font-size: 64px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -2.5px;
  height: 160px;
  top: 15px;

  div {
    position: absolute;
    width: 512px;
  }
`;

const Shoutout = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <FadeInSlider
        headerTitle={
          <HeaderTitle>
            <div>{t('website.experienceSport')}</div>
          </HeaderTitle>
        }
        headerText={[
          t('website.theOnlySportsApp'),
          t('website.buildYourOwnWorld'),
          t('website.chooseTheFeatures'),
          t('website.interactWithAthletes')
        ]}
        sliderElements={[
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.subscribe!'),
            content: t('website.getContent')
          },
          {
            image: require('assets/images/tennis-phone-tilted.png'),
            title: t('website.connect!'),
            content: t('website.unlimitedAccess')
          },
          {
            image: require('assets/images/cheering-phone-tilted.png'),
            title: t('website.stream!'),
            content: t('website.streamGamesFrom')
          }
        ]}
      />
    </Wrapper>
  );
};

export default Shoutout;
